import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';

const ProductGrid = ({
  filteredProducts,
  selectedProducts,
  hoveredProductId,
  editingProductId,
  editFormData,
  filters,
  categories,
  handleMouseEnter,
  handleMouseLeave,
  handleProductSelect,
  handleEditProduct,
  openDeleteDialog,
  handleCopyProduct,
  handleCancelEdit,
  handleSaveEdit,
  handleEditFormChange,
  setEditFormData,
  imageSetOpenDialog,
  getCategoryFilters,
  handleCategoryClick,
  SlideCarousel,
  ProductImagePreview
}) => {
  return (
    <div className="product-grid">
      {filteredProducts.map((product) => (
        <div
          key={product.id}
          className="product-card"
          onMouseEnter={() => handleMouseEnter(product.id)}
          onMouseLeave={handleMouseLeave}
          style={{
            backgroundColor: selectedProducts.includes(product.id) ? '#def6dd' : 'white',
          }}
        >
          {(hoveredProductId === product.id || selectedProducts.includes(product.id)) && (
            <div className="checkbox-container" style={{ display: 'flex', alignItems: 'left' }}>
              <input
                type="checkbox"
                checked={selectedProducts.includes(product.id)}
                onChange={() => handleProductSelect(product.id)}
                style={{ marginRight: '10px' }}
              />
            </div>
          )}
          <div className="product-card-icons">
            <i className="fas fa-edit edit-icon" onClick={() => handleEditProduct(product.id)}></i>
            <i className="fas fa-trash delete-icon" onClick={() => openDeleteDialog(product.id)}></i>
            <i
              className="fas fa-copy copy-icon"
              onClick={() => handleCopyProduct(product.id)}
              title="Copiar produto"
            ></i>
          </div>

          {editingProductId === product.id ? (
            <Dialog open={true} onClose={handleCancelEdit}>
              <DialogTitle>Editar Produto</DialogTitle>
              <DialogContent>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleSaveEdit(product.id);
                  }}
                >
                  <TextField
                    label="Ordem"
                    name="order"
                    value={editFormData.order}
                    onChange={handleEditFormChange}
                    fullWidth
                    margin="normal"
                  />
                  <TextField
                    label="Nome"
                    name="name"
                    value={editFormData.name}
                    onChange={handleEditFormChange}
                    fullWidth
                    margin="normal"
                  />
                  {editFormData.type !== 'slide' && (
                    <>
                      <TextField
                        label="Preço 10x"
                        name="price10x"
                        value={editFormData.price10x.replace(/\./g, ',')}
                        onChange={(e) => {
                          const { name, value } = e.target;
                          setEditFormData(prevData => ({
                            ...prevData,
                            [name]: value.replace(/\./g, ',')
                          }));
                        }}
                        fullWidth
                        margin="normal"
                      />

                      <TextField
                        label="Preço Crédito/Débito"
                        name="price6x"
                        value={editFormData.price6x.replace(/\./g, ',')}
                        onChange={(e) => {
                          const { name, value } = e.target;
                          setEditFormData(prevData => ({
                            ...prevData,
                            [name]: value.replace(/\./g, ',')
                          }));
                        }}
                        fullWidth
                        margin="normal"
                      />

                      <TextField
                        label="Preço PIX"
                        name="price_pix"
                        value={editFormData.price_pix.replace(/\./g, ',')}
                        onChange={(e) => {
                          const { name, value } = e.target;
                          setEditFormData(prevData => ({
                            ...prevData,
                            [name]: value.replace(/\./g, ',')
                          }));
                        }}
                        fullWidth
                        margin="normal"
                      />

                      <TextField
                        label="Desconto Máximo"
                        name="desconto_maximo"
                        value={editFormData.desconto_maximo.replace(/\./g, ',')}
                        onChange={(e) => {
                          const { name, value } = e.target;
                          setEditFormData(prevData => ({
                            ...prevData,
                            [name]: value.replace(/\./g, ',')
                          }));
                        }}
                        fullWidth
                        margin="normal"
                      />

                      <TextField
                        label="Valor Máximo"
                        name="valor_maximo"
                        value={editFormData.valor_maximo.replace(/\./g, ',')}
                        onChange={(e) => {
                          const { name, value } = e.target;
                          setEditFormData(prevData => ({
                            ...prevData,
                            [name]: value.replace(/\./g, ',')
                          }));
                        }}
                        fullWidth
                        margin="normal"
                      />
                      <FormControl fullWidth margin="normal">
                        <InputLabel>Grupo</InputLabel>
                        <Select
                          name="group"
                          value={editFormData.group}
                          onChange={handleEditFormChange}
                        >
                          {[1, 2, 3, 4, 'CB'].map((option) => (
                            <MenuItem key={option} value={option}>
                              {option}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </>
                  )}
                  <FormControl fullWidth margin="normal">
                    <InputLabel>Filtro</InputLabel>
                    <Select
                      name="filter"
                      value={editFormData.filter}
                      onChange={handleEditFormChange}
                    >
                      {filters.map((filter) => (
                        <MenuItem key={filter.id} value={filter.id}>
                          {filter.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl fullWidth margin="normal">
                    <InputLabel>Categoria</InputLabel>
                    <Select
                      name="category"
                      value={editFormData.category}
                      onChange={handleEditFormChange}
                    >
                      {categories
                        .filter((cat) => cat.filter === editFormData.filter)
                        .map((cat) => (
                          <MenuItem key={cat.id} value={cat.id}>
                            {cat.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                  {editFormData.type === 'slide' && (() => {
                    const images = editFormData.images || [];
                    return (
                      <div
                        className="image-upload-box"
                        onClick={() => imageSetOpenDialog(true)}
                        style={{
                          border: `2px dashed ${images.length > 0 ? '#1976d2' : '#bbb'}`,
                          borderRadius: 12,
                          padding: 16,
                          cursor: 'pointer',
                          transition: 'border-color 0.2s, background 0.2s',
                          background: images.length > 0 ? '#f0f7ff' : 'transparent',
                          marginTop: 12,
                        }}
                        onMouseEnter={e => e.currentTarget.style.borderColor = '#1976d2'}
                        onMouseLeave={e => e.currentTarget.style.borderColor = images.length > 0 ? '#1976d2' : '#bbb'}
                      >
                        {images.length === 0 ? (
                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, color: '#888' }}>
                            <ImageIcon style={{ fontSize: 40 }} />
                            <span style={{ fontSize: 14 }}>Clique para adicionar imagens do slide</span>
                          </div>
                        ) : (
                          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                              {images.map((img, i) => (
                                <div key={i} style={{ position: 'relative', width: 64, height: 64 }}>
                                  <img
                                    src={img.image_url.startsWith('http') ? img.image_url : `/${img.image_url}`}
                                    alt={`slide-${i}`}
                                    style={{ width: 64, height: 64, objectFit: 'cover', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}
                                  />
                                  <button
                                    onClick={e => {
                                      e.stopPropagation();
                                      setEditFormData(prev => ({
                                        ...prev,
                                        images: prev.images.filter((_, idx) => idx !== i)
                                      }));
                                    }}
                                    style={{
                                      position: 'absolute', top: -6, right: -6,
                                      background: '#e53935', color: '#fff', border: 'none',
                                      borderRadius: '50%', width: 20, height: 20, fontSize: 12,
                                      cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    }}
                                  >×</button>
                                </div>
                              ))}
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#1976d2', fontSize: 13 }}>
                              <ImageIcon style={{ fontSize: 16 }} />
                              <span>{images.length} imagem{images.length > 1 ? 'ns' : ''} · clique para adicionar mais</span>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })()}

                  {editFormData.type !== 'slide' && (
                    <div style={{ display: 'flex' }}>
                      <IconButton onClick={() => imageSetOpenDialog(true)}>
                        <ImageIcon style={{ fontSize: '100%', height: '100%', fontSize: 'larger' }} />
                      </IconButton>
                      <TextField
                        label="Caminho da imagem"
                        name="image_path"
                        value={editFormData.image_path.replace('img/', '')}
                        onChange={handleEditFormChange}
                        fullWidth
                        margin="normal"
                      />
                    </div>
                  )}
                </form>
              </DialogContent>
              <DialogActions>
                <Button type="submit" onClick={() => handleSaveEdit(product.id)} style={{ color: "black" }}>
                  Salvar
                </Button>
                <Button onClick={handleCancelEdit} style={{ color: "black" }}>
                  Cancelar
                </Button>
              </DialogActions>
            </Dialog>
          ) : (
            <div key={product.id}>
              <p style={{ fontWeight: 'bold', color: '#2c3e50', fontSize: '1.2rem' }}>
                {product.name}
              </p>
              <div style={{ marginBottom: '.8rem', display: 'flex', gap: '.3rem' }}>
                {getCategoryFilters(product.category).map(filterName => (
                  <span
                    key={filterName}
                    style={{
                      display: 'inline-block',
                      backgroundColor: '#8fd400',
                      borderRadius: '12px',
                      padding: '2px 8px',
                      fontSize: '12px',
                      color: '#333',
                      fontWeight: 'bold',
                    }}
                  >
                    {filterName}
                  </span>
                ))}

                <span
                  style={{
                    display: 'inline-block',
                    backgroundColor: '#e0e0e0',
                    borderRadius: '12px',
                    padding: '2px 8px',
                    fontSize: '12px',
                    color: '#333',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    marginRight: '1px',
                  }}
                  onClick={() => handleCategoryClick(product.category)}
                >
                  {categories.find((cat) => cat.id === product.category)?.name || 'Unknown'}
                </span>
              </div>
              <p><strong>Ordem:</strong> {product.order}</p>
              {product.type !== 'slide' ? (
                <>
                  <p><strong>Grupo:</strong> {product.group}</p>
                  <p><strong>Preço 10x:</strong> {product.price10x}</p>
                  <p><strong>Créd/Deb:</strong> {product.price6x}</p>
                  <p><strong>Preço PIX:</strong> {product.price_pix}</p>
                  <p><strong>Desc. Max:</strong> {product.desconto_maximo}</p>
                  <p><strong>Valor Máximo:</strong> {product.valor_maximo}</p>
                  <ProductImagePreview imagePath={product.image_path} />
                </>
              ) : (
                <SlideCarousel images={product.images} />
              )}
              <p><strong>Criado em:</strong> {new Date(product.created_on).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' }).replace(',', '')}</p>
              <p><strong>Editado pela última vez:</strong> {new Date(product.last_edit_on).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' }).replace(',', '')}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ProductGrid;